
import type { BaseQueryFn } from '@reduxjs/toolkit/query'
import axios from 'axios'
import type { AxiosRequestConfig, AxiosError } from 'axios'
import { msalInstance, scopesMS } from '../../config/authConfig'
import { AccountInfo } from '@azure/msal-browser'

/**
 * It retrieves the token from the active account in the msal instance
 * 
 * @returns string token
 */
const getToken = async () => {
  let account = msalInstance.getActiveAccount() as AccountInfo;
  if (!account) {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
      account = msalInstance.getActiveAccount() as AccountInfo;
    } else {
      throw new Error("Utilisateur non connecté");
    }
  }

  const response = await msalInstance.acquireTokenSilent({
    scopes: scopesMS,
    account,
  });

  return response.accessToken;
}

/**
 * It creates a base query function for axios
 * 
 * @param baseUrl the base url of the api
 * @returns BaseQueryFn
 */
const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: '' }
  ): BaseQueryFn<AxiosRequestConfig,
    unknown,
    unknown
  > =>
    async (config) => {
      const token = await getToken();
      config.url = baseUrl + config.url;
      config.headers = {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...config.headers,
      };
      try {
        const result = await axios(config);
        return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      }
    }
  }

export default axiosBaseQuery;
